/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5d

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { css } from 'styled-components';
import {
  getIconPath,
  routerPush,
  getBrandInCaps,
  getAPIConfig,
  getSiteId,
  getDynamicBadgeQty,
  getBrand,
  isPJP,
  isCanada,
  getAssetHostURL,
  isMobileWeb,
  getStringAcronym,
  DIMENSION92_TEXT,
  urlContainsQuery,
  getDynamicBadgePackQty,
} from '@tcp/core/src/utils';
import {
  getGAPageName,
  getProductCategory,
  getSearchRedirectObj,
  getWishListTrackingObj,
  getCategoryIdAndName,
  setSessionStorage,
  getBrandName,
} from '@tcp/core/src/utils/utils.web';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { FAVORITES_VIEW_BUTTON_FILL } from '@tcp/core/src/constants/brandSpecific.constants';
import { currencyConversion } from '@tcp/core/src/components/features/CnC/CartItemTile/utils/utils';
import Notification from '@tcp/core/src/components/common/molecules/Notification';
import Recommendations from '@tcp/core/src/components/common/molecules/Recommendations';
import { KEY_CODES } from '@tcp/core/src/constants/keyboard.constants';
import ProductRating from '@tcp/core/src/components/features/browse/ProductDetail/molecules/ProductRating/ProductRating';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import Promotions from '@tcp/core/src/components/common/organisms/Promotions';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Col from '@tcp/core/src/components/common/atoms/Col';
import Row from '@tcp/core/src/components/common/atoms/Row';
import CustomBadge from '@tcp/core/src/components/features/browse/ProductListing/atoms/CustomBadge';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import DiscoveryButton from '@tcp/web/src/components/common/vendors/Syte/DiscoveryButton';
import AnimatedSearchIcon from '@tcp/web/src/components/common/atoms/AnimatedSearchIcon';
import { TOP_RATED, BEST_SELLER, MOST_FAVORITED } from '@tcp/core/src/constants/badge.constants';
import { getParsedVariantDetails } from '@tcp/core/src/components/features/browse/PlpTile/views/plpTileHelpers/plpTileCommonHelpers';
import ZoneOneBadges from '@tcp/core/src/components/features/browse/PlpTile/views/ZoneOneBadges.view';
import ZoneSixBadges from '@tcp/core/src/components/features/browse/PlpTile/views/ZoneSixBadges.view';
import { ZoneOneBadgesWrapper } from '@tcp/core/src/components/features/browse/PlpTile/views/styles/ZoneOneBadges.style';
import { getZoneOneBadgesArray } from '@tcp/core/src/utils/badge.util';
import AddedtoBagDynamicStore from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBagDynamicStore.js';
import productGridItemPropTypes, {
  productGridDefaultProps,
} from '../propTypes/ProductGridItemPropTypes';
import pushEventToAdobeAnalytics from '../../../../../../../adobeAnalytics/adobe.utils';
import { getLocator, isClient, fireEnhancedEcomm, isGymboree } from '../../../../../../../utils';
import { AtbIcon } from '../../../../PlpTile/views/styles/SubmitButton.style';

import {
  getImagesToDisplay,
  getMapSliceForColorProductId,
  getRearrangedImgUrls,
  checkInWishlistUtil,
} from '../utils/productsCommonUtils';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles, {
  StyledItemContainerInner,
  StyledPointsAndRewards,
  StyledPointsAndRewards1,
  StyledPointsAndRewards2,
  StyledPointsAndRewardsOr,
  StyledPromotionWrapper,
  StyledAddToBagButton,
  StyledTopBadgeContainer,
  StyledInfluencerPickBadgeContainer,
  StyledMoveItemContainer,
  StyledMoveItemButton,
  StyledMoveItemSection,
  StyledFavoriteMovePurchaseSection,
  StyledFavoriteEditItemButton,
  StyledAccordianItemArrow,
  StyledEmptyColorChipsContainer,
  StyledExtendedSizeText,
  StyledProductImageContainer,
  StyledSeeSuggestedItem,
  StyledCloseButtonIcon,
  StyledCloseButton,
  StyledNoRatingSpaceMobileSNJ,
  StyledSuggestedLabel,
  StyledHorizontalRule,
} from '../styles/ProductsGridItem.style';
import { getPromotionalMessage } from '../utils/utility';
import {
  ProductTitle,
  ProductPricesSection,
  PromotionalMessage,
  CreateWishList,
  WishListIcon,
  EditButton,
} from './ProductItemComponents';
import {
  getTopBadge,
  getPayloadForOneClickATC,
  hideProductOriginalPrice,
  getOriginalPrice,
} from './ProductGridItem.util';
import { AVAILABILITY } from '../../../../Favorites/container/Favorites.constants';
import { getCartItemInfo } from '../../../../../CnC/AddedToBag/util/utility';
import RecommendationsAbstractor from '../../../../../../../services/abstractors/common/recommendations';
import { setLoyaltyLocation } from '../../../../../../../constants/analytics';
import { SLASH_C_ROUTE } from '../../../../../../../constants/plp.constants';
import { isShopThisStoreModeOn } from '../../../../../../../reduxStore/selectors/session.selectors';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblRemove,
} from '../../../../../../../utils/labels/globalActions.labels';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '../../../../../../../utils/labels/globalCommonBrowseLabels.labels';
import { fileteredProductGridItemLabels } from './ProductGridItem.labels';
import { PLPLabels, PLP_LABELS } from '../../../../../../../utils/labels/browse/PLP.labels';
import { globalSortingLabels } from '../../../../../../../utils/labels/globalSorting.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
} from '../../../../../../../utils/labels/globalGeneric.labels';
import { FAVORITES_LABELS, FavoriteLabels } from '../../../../Favorites/labels/Favorites.labels';
import { SLP_SUB_LABELS, slpSubLabels } from '../../../../../../../utils/labels/browse/SLP.labels';
import StoreSpecialMsg from '../../../../PlpTile/views/StoreSpecialMsg';

const ProductColorChipWrapper = dynamic(
  () =>
    import(
      /* webpackChunkName: "product-color-chip-wrapper" */
      '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductColorChipWrapper'
    ),
  {
    loading: () => {
      const skeletonStyles = css`
        height: 15px;
        margin-top: 4px;
        margin-bottom: 11px;
        @media ${(props) => props.theme.mediaQuery.medium} {
          margin-top: 8px;
          margin-bottom: 18px;
        }
        @media ${(props) => props.theme.mediaQuery.large} {
          height: 20px;
        }
      `;
      return <LoaderSkelton inheritedStyles={skeletonStyles} />;
    },
    ssr: false,
  }
);

const getSiteIdWithDefault = () => {
  return getSiteId() || 'us';
};

const getSeoUrl = (seotoken) => {
  return `/p/${seotoken}`;
};

const getPdpAsPathurl = (
  isProductBrandOfSameDomain,
  pdpUrl,
  crossDomain,
  cookieToken,
  brandSpecificCrossDomain,
  brand,
  isCrossBrandMerchandisingEnabled,
  seoToken,
  siteId
) => {
  let pdpLinkPath = pdpUrl;
  if (seoToken) {
    pdpLinkPath = getSeoUrl(seoToken);
  }
  if (isProductBrandOfSameDomain) {
    return pdpLinkPath;
  }
  if (isCrossBrandMerchandisingEnabled)
    return `/${siteId}${pdpLinkPath}$brand=${brand.toUpperCase()}`;
  if (cookieToken)
    return `${brandSpecificCrossDomain[brand.toUpperCase()]}${pdpLinkPath}${
      urlContainsQuery(pdpUrl) ? '&' : '?'
    }ct=${cookieToken}`;
  return `${brandSpecificCrossDomain[brand.toUpperCase()]}${pdpLinkPath}`;
};
class ProductsGridItem extends React.PureComponent {
  commmonBrowseLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_COMMON_BROWSE_LABELS,
    globalCommonBrowseLabels
  );

  globalActions = getLabelFromCopyOrFromTranslation('global.actions', GlobalActionsLabels);

  lblPlpTiles = getLabelFromCopyOrFromTranslation(PLP_LABELS, PLPLabels);

  // eslint-disable-next-line react/forbid-prop-types
  static propTypes = { ...productGridItemPropTypes, forwardedRef: PropTypes.object };

  static defaultProps = { ...productGridDefaultProps };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  constructor(props) {
    super(props);
    const { colorsMap, generalProductId } = props.item;
    if (colorsMap) {
      this.colorsExtraInfo = {
        [colorsMap[0].color.name]: colorsMap[0].miscInfo,
      };
    }
    const colorProductId = colorsMap ? colorsMap[0].colorProductId : generalProductId;
    const {
      item: {
        productInfo: { pdpUrl, seoToken },
      },
      isCrossBrandMerchandisingEnabled,
      isFavoriteView,
      cookieToken,
    } = props;
    const labels = {
      ...{
        PLP: {
          plpTiles: getLabelFromCopyOrFromTranslation(PLP_LABELS, PLPLabels),
          seoText: getLabelFromCopyOrFromTranslation('PLP.seoText', PLPLabels),
        },
      },
      ...{
        global: {
          CommonBrowseLabels: getLabelFromCopyOrFromTranslation(
            GLOBAL_COMMON_BROWSE_LABELS,
            globalCommonBrowseLabels
          ),
          Sorting: getLabelFromCopyOrFromTranslation('global.Sorting', globalSortingLabels),
          generic: getLabelFromCopyOrFromTranslation(GLOBAL_GENERIC_LABELS, GlobalGenericLabels),
        },
      },

      ...getLabelFromCopyOrFromTranslation(FAVORITES_LABELS, FavoriteLabels),
      ...getLabelFromCopyOrFromTranslation(SLP_SUB_LABELS, slpSubLabels),
    };
    this.productGridItemLabels = fileteredProductGridItemLabels(labels);
    this.favLabels = getLabelFromCopyOrFromTranslation(FAVORITES_LABELS, FavoriteLabels);
    const currentSiteBrand = getBrandInCaps();
    const apiConfigObj = getAPIConfig();
    const { brandSpecificCrossDomain } = apiConfigObj;
    const itemBrand = props.item?.itemInfo?.brand
      ? props.item.itemInfo.brand.toUpperCase()
      : currentSiteBrand;
    const crossDomain = brandSpecificCrossDomain[itemBrand];
    const isProductBrandOfSameSiteBrand =
      currentSiteBrand === itemBrand || (!isFavoriteView && isCrossBrandMerchandisingEnabled);
    const siteId = getSiteIdWithDefault();
    let itempdpUrl =
      props?.item?.productInfo?.pdpUrl?.startsWith(siteId) ||
      props?.item?.productInfo?.pdpUrl?.startsWith(`/${siteId}`)
        ? props.item.productInfo.pdpUrl.replace(siteId, '')
        : props?.item?.productInfo?.pdpUrl;
    if (isFavoriteView) {
      itempdpUrl = getPdpAsPathurl(
        isProductBrandOfSameSiteBrand,
        itempdpUrl,
        crossDomain,
        cookieToken,
        brandSpecificCrossDomain,
        itemBrand,
        isCrossBrandMerchandisingEnabled,
        seoToken,
        siteId
      );
    }
    const cd66 = props?.item?.dimension66;
    if (cd66) {
      itempdpUrl = itempdpUrl.concat('?fromBIA=1');
    }
    const getCrossBrandPDPURL = () => {
      return isFavoriteView && isCrossBrandMerchandisingEnabled
        ? `/${siteId}${itempdpUrl}$brand=${itemBrand?.toUpperCase()}`
        : `${crossDomain}/${getSiteId()}${pdpUrl}${cd66 ? `?fromBIA=1` : ''}`;
    };
    this.state = {
      isInDefaultWishlist: props.item.miscInfo.isInDefaultWishlist,
      selectedColorProductId: colorProductId,
      currentImageIndex: 0,
      pdpUrl: isProductBrandOfSameSiteBrand || isFavoriteView ? itempdpUrl : getCrossBrandPDPURL(),
      isAltImgRequested: false,
      isMoveItemOpen: false,
      generalProductId: '',
      errorProductId: '',
      showDiscoveryIcon: false,
      hasMounted: false,
    };
    const { onQuickViewOpenClick, page } = this.props;
    const { selectedColorProductId } = this.state;
    this.handleOpenQuickViewClick = () =>
      onQuickViewOpenClick(generalProductId, selectedColorProductId, generalProductId, page);
    this.handleImageChange = (index) => this.setState({ currentImageIndex: index });
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { isLoggedIn, onAddItemToFavorites, isSearchListing } = nextProps;
    const { generalProductId } = prevState;

    if (isLoggedIn && generalProductId !== '') {
      onAddItemToFavorites({
        colorProductId: generalProductId,
        productSkuId: null,
        page: isSearchListing ? 'SLP' : 'PLP',
      });
      return { generalProductId: '' };
    }
    return null;
  }

  componentDidMount() {
    const { isFavoriteView, isSyteEnabled } = this.props;
    this.setState({ hasMounted: true });
    if (isFavoriteView) {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
    if (isSyteEnabled) this.setState({ showDiscoveryIcon: isSyteEnabled });
  }

  // DT-32496
  // When using the back button isInDefaultWishlist gets set to undefined in constructor
  // Need to update the value when we receive the latest props
  /* eslint-disable-next-line */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      item: {
        miscInfo: { isInDefaultWishlist },
      },
    } = nextProps;
    const { isInDefaultWishlist: currentIsInDefaultWishlist } = this.state;
    if (currentIsInDefaultWishlist === undefined) {
      this.setState({ isInDefaultWishlist });
    }
    const {
      item: { colorsMap },
    } = this.props;
    if (colorsMap !== nextProps.item.colorsMap) {
      this.colorsExtraInfo = {
        [nextProps.item.colorsMap[0].color.name]: nextProps.item.colorsMap[0].miscInfo,
      };
    }
  }

  componentWillUnmount() {
    const { isFavoriteView } = this.props;
    if (isFavoriteView) {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }

  getQuickViewInitialValues() {
    const {
      item: { colorsMap },
    } = this.props;
    const { selectedColorProductId } = this.state;
    const colorEntry =
      colorsMap && colorsMap.find((entry) => entry.colorProductId === selectedColorProductId);
    return colorEntry && colorEntry.color && colorEntry.color.name
      ? { color: colorEntry.color.name }
      : undefined;
  }
  /**
   * This function returns array of suggested Items
   * @param {*} item
   */

  checkAndRenderSuggestedItem = (item) => {
    if (!item.skuInfo) {
      return false;
    }
    const { seeSuggestedDictionary, hasSuggestedProduct } = this.props;
    const {
      skuInfo: { colorProductId },
    } = item;
    const suggestedItem = {
      status: false,
      attributes: null,
      hasSuggestedProduct,
    };

    if (!colorProductId) {
      return null;
    }

    const outOfStockProduct =
      colorProductId && seeSuggestedDictionary && seeSuggestedDictionary[colorProductId];
    const outOfStockColorProductId = outOfStockProduct && outOfStockProduct.colorProductId;
    const suggestedAttributes = outOfStockProduct && outOfStockProduct.attributes;

    if (outOfStockColorProductId && outOfStockColorProductId === colorProductId) {
      suggestedItem.status = true;
      suggestedItem.attributes = suggestedAttributes;
    }
    return suggestedItem;
  };

  /**
   * This function returns array of images for carousal and also decides whether to show image carousal or not
   * @param {*} imageUrls
   */
  getImageCarouselOptions(imageUrls) {
    const { hideImageCarousel } = this.props;

    return hideImageCarousel ? imageUrls.slice(0, 1) : imageUrls;
  }

  /**
   * This function closes the move item container onclick
   * @param {object} event
   */
  handleClickOutside = (event) => {
    const { isMoveItemOpen } = this.state;
    const openItem = document.querySelector('.move-item-section');
    const isChildren =
      openItem &&
      openItem.contains &&
      typeof openItem.contains === 'function' &&
      openItem.contains(event.target);
    if (
      !isChildren &&
      event.target &&
      event.target.classList &&
      !event.target.classList.contains('move-item-button') &&
      isMoveItemOpen
    ) {
      this.setState({
        isMoveItemOpen: false,
      });
    }
  };

  crossIcon = () => {
    const { onDismissSuggestion, outOfStockColorProductId, isSuggestedItem, theme } = this.props;

    return isSuggestedItem ? (
      <StyledCloseButton
        aria-label="close"
        onClick={() => onDismissSuggestion(outOfStockColorProductId)}
        theme={theme}
      >
        <StyledCloseButtonIcon theme={theme} viewBox="0 0 25 25" aria-hidden="true">
          <path
            fill="#a0a0a0"
            fillRule="nonzero"
            d="M14.107 12.5l10.56-10.56A1.136 1.136 0 1 0 23.06.333L12.5 10.893 1.94.333A1.136 1.136 0 1 0 .333 1.94l10.56 10.56L.333 23.06a1.136 1.136 0 1 0 1.607 1.607l10.56-10.56 10.56 10.56c.222.222.513.333.804.333a1.136 1.136 0 0 0 .803-1.94L14.107 12.5z"
          />
        </StyledCloseButtonIcon>
      </StyledCloseButton>
    ) : null;
  };

  dismissBtn = () => {
    const { onDismissSuggestion, outOfStockColorProductId, isSuggestedItem, theme } = this.props;
    return isSuggestedItem ? (
      <div>
        <StyledMoveItemContainer>
          <StyledMoveItemButton
            theme={theme}
            className="move-item-button dismiss-btn"
            onClick={() => onDismissSuggestion(outOfStockColorProductId)}
          >
            <StyledSeeSuggestedItem
              fontFamily="secondary"
              fontSize={['fs10', 'fs12', 'fs14']}
              color="gray.900"
            >
              {this.lblPlpTiles.lbl_dismiss}
            </StyledSeeSuggestedItem>
          </StyledMoveItemButton>
        </StyledMoveItemContainer>
      </div>
    ) : null;
  };

  handleWishListObj = () => {
    const { isLoggedIn, trackWishListClick, isSearchListing } = this.props;
    const loyaltyLocation = `favorites|${isSearchListing ? 'SLP' : 'PLP'}`;
    setLoyaltyLocation(loyaltyLocation);
    const wishListObj = getWishListTrackingObj(loyaltyLocation, isLoggedIn);
    trackWishListClick(wishListObj);
  };

  handleAddToWishlist = () => {
    const {
      item: {
        productInfo: { generalProductId },
        itemInfo: { itemId } = {},
      },
      onAddItemToFavorites,
      isLoggedIn,
      removeFavItem,
      isSearchListing,
      isSuggestedItem,
      item,
      deleteFavItemInProgressFlag,
    } = this.props;
    const { selectedColorProductId } = this.state;
    if (deleteFavItemInProgressFlag) {
      return;
    }
    if (isSuggestedItem) {
      this.handleQuickViewOpenClick();
    } else if (removeFavItem) {
      removeFavItem({ itemId, products: item.productInfo });
    } else {
      if (isClient()) this.handleWishListObj();
      onAddItemToFavorites({
        colorProductId: selectedColorProductId || generalProductId,
        page: isSearchListing ? 'SLP' : 'PLP',
        products: item.productInfo,
      });
      this.setState({ errorProductId: selectedColorProductId || generalProductId });
      if (isClient() && isLoggedIn) {
        this.setState({ isInDefaultWishlist: true });
      } else {
        this.setState({ generalProductId: selectedColorProductId || generalProductId });
      }
    }
  };

  handleRemoveFromWishList = () => {
    const { deleteFavItemInProgressFlag } = this.props;
    if (deleteFavItemInProgressFlag) {
      return;
    }
    const {
      item,
      item: {
        miscInfo: { newItemId },
      },
      onSetLastDeletedItemIdAction,
      wishList,
    } = this.props;
    const itemId = item?.productInfo?.generalProductId;
    const wishListProducts = wishList?.items;
    const itemIdFromWishlist = wishListProducts.filter((product) => {
      return product?.productInfo?.generalProductId === itemId;
    });
    onSetLastDeletedItemIdAction({
      externalId: wishList?.id,
      productId: item?.productInfo?.generalProductId,
      itemId: newItemId || itemIdFromWishlist[0]?.itemInfo?.itemId,
      notFromFavoritePage: true,
      wishListName: wishList?.displayName,
    });
  };

  renderQuickViewCardOrLink = () => {};

  handleOpenAltImages = () => {
    const { isAltImgRequested } = this.state;
    if (isAltImgRequested) {
      return;
    }
    const { resetSlpLoadingState, acrossBrandApiCalled, alternateBrandsShown } = this.props;
    if (acrossBrandApiCalled) {
      resetSlpLoadingState({ alternateBrandName: alternateBrandsShown });
    }
    this.setState({ isAltImgRequested: true });
  };

  renderCustomRatings = (renderWrapper = false) => {
    const {
      item,
      isHidePLPRatings,
      starRatingSize,
      isBagPage,
      isSNJEnabled,
      isNewPDPEnabled,
      theme,
      isNewPLPAtbCardTileEnabled,
      isConfirmationPage,
      isTileRedesignAB,
      isRatingRedesignAbTest,
    } = this.props;
    const {
      productInfo: { ratings, reviewsCount },
    } = item;

    let customRatings = null;
    if (!ratings && isSNJEnabled && isNewPDPEnabled) {
      customRatings = <StyledNoRatingSpaceMobileSNJ theme={theme} />;
    }
    customRatings = !isHidePLPRatings && !!ratings && (
      <ProductRating
        ratings={ratings || 0}
        reviews={reviewsCount}
        starRatingSize={starRatingSize}
        isBagPage={isBagPage}
        isNewPJPPDPRedesignEnabled={isNewPLPAtbCardTileEnabled}
        isConfirmationPage={isConfirmationPage}
        isTileRedesignAB={isTileRedesignAB}
        isRatingRedesignAbTest={isRatingRedesignAbTest}
      />
    );
    if (!customRatings) return null;

    return renderWrapper ? (
      <>
        {isNewPLPAtbCardTileEnabled && !(isTileRedesignAB || isRatingRedesignAbTest) && (
          <StyledHorizontalRule />
        )}
        <div className="plp-new-rating-wrapper"> {customRatings}</div>
      </>
    ) : (
      <>
        {isNewPLPAtbCardTileEnabled && !(isTileRedesignAB || isRatingRedesignAbTest) && (
          <StyledHorizontalRule />
        )}
        {customRatings}
      </>
    );
  };

  renderSuggestedLabel = () => {
    const { isSuggestedItem, theme } = this.props;

    return isSuggestedItem ? (
      <StyledSuggestedLabel
        dataLocator="plp_offer_price"
        mobileFontFamily="secondary"
        fontSize="fs10"
        fontWeight="extrabold"
        color="white"
        theme={theme}
      >
        {this.lblPlpTiles.lbl_suggested}
      </StyledSuggestedLabel>
    ) : null;
  };

  /* get color chip component */
  getColorChipContainer = (curentColorEntry, itemBrand, pdpUrl, primaryBrand) => {
    const {
      theme,
      item: {
        colorsMap,
        skuInfo,
        relatedSwatchImages,
        imagesByColor,
        productInfo: { bundleProduct },
      },
      isPLPredesign,
      isFavoriteView,
      isSuggestedItem,
      compactView,
      inGridPlpRecommendation,
      alternateBrand,
      isNewSwatchUrlEnabled,
      isNewPLPAtbCardTileEnabled,
      alternateBrandsShown,
      acrossBrandApiCalled,
      isBundleProductABTest,
      isTileRedesignAB,
    } = this.props;
    if (inGridPlpRecommendation) return null;
    const colorProductId = skuInfo && skuInfo.colorProductId;
    const isBundleProduct = !isBundleProductABTest && bundleProduct;
    if (isSuggestedItem || compactView) {
      return false;
    }
    const ChipProps = {
      className: 'color-chips-container',
      showColorEvenOne: true,
      isPLPredesign: { isPLPredesign },
    };
    if (colorProductId && !isSuggestedItem) {
      return (
        <ProductColorChipWrapper
          selectedColorId={colorProductId}
          skuInfo={skuInfo}
          isFavoriteView={isFavoriteView}
          imagesByColor={imagesByColor}
          itemBrand={itemBrand}
          pdpUrl={pdpUrl}
          primaryBrand={primaryBrand}
          alternateBrand={alternateBrand}
          isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
          isNewPLPAtbCardTileEnabled={isNewPLPAtbCardTileEnabled}
          alternateBrandsShown={alternateBrandsShown}
          acrossBrandApiCalled={acrossBrandApiCalled}
          isBundleProduct={isBundleProduct}
          {...ChipProps}
        />
      );
    }
    return colorsMap && colorsMap.length >= 1 ? (
      <ProductColorChipWrapper
        onChipClick={this.handleChangeColor}
        maxVisibleItems={5}
        selectedColorId={curentColorEntry.color.name}
        colorsMap={colorsMap}
        imagesByColor={imagesByColor}
        relatedSwatchImages={relatedSwatchImages}
        itemBrand={itemBrand}
        pdpUrl={pdpUrl}
        primaryBrand={primaryBrand}
        alternateBrand={alternateBrand}
        isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
        alternateBrandsShown={alternateBrandsShown}
        acrossBrandApiCalled={acrossBrandApiCalled}
        isBundleProduct={isBundleProduct}
        isTileRedesignAB={isTileRedesignAB}
        {...ChipProps}
      />
    ) : (
      <StyledEmptyColorChipsContainer theme={theme} />
    );
  };

  getDisplayPriceRange = (showPriceRange, isFavoriteView, priceRange) => {
    return Boolean(
      showPriceRange &&
        !isFavoriteView &&
        ((priceRange?.lowOfferPrice && priceRange?.highOfferPrice) ||
          (priceRange?.lowListPrice && priceRange.highListPrice))
    );
  };

  /* function to get product Name and brand */

  getRenderProductInfo = () => {
    const {
      item,
      loadedProductCount,
      sqnNmbr,
      unbxdId,
      viaModule,
      dataSource,
      isSearchPage,
      page,
      cookieToken,
      alternateBrand,
      isSoldOut,
      bundleProduct,
      isSearchListing,
      isRecommendation,
      isBopisFilterOn,
      categoryId,
      currentCategoryId,
      setCurrentCategoryIdActn,
    } = this.props;
    const {
      miscInfo: { categoryId: categoryIdL3 },
      productInfo: { generalProductId, primaryBrand },
    } = item;
    const { pdpUrl } = this.state;
    const categoryIdToCheck = currentCategoryId || categoryIdL3 || categoryId;
    const sqnNmb = sqnNmbr;
    const isProductBrandOfSameDomain = this.getIsProductBrandSameDomain();
    const googleAnalyticsData = this.updateGoogleAnalyticsData;
    const productTitle = item && item.productInfo && item.productInfo.name;
    const isFromPLPPage = isClient() && window?.location?.href?.includes(SLASH_C_ROUTE);

    return (
      <ProductTitle
        name={productTitle}
        pdpUrl={pdpUrl}
        loadedProductCount={loadedProductCount}
        viaModule={viaModule}
        dataSource={dataSource}
        analyticsData={{
          pId: generalProductId,
          prank: sqnNmb,
          requestId: unbxdId,
        }}
        isProductBrandOfSameDomain={isProductBrandOfSameDomain}
        isSearchPage={isSearchPage}
        page={page}
        isSoldOut={isSoldOut}
        cookieToken={cookieToken}
        bundleProduct={bundleProduct}
        googleAnalyticsData={googleAnalyticsData}
        alternateBrand={alternateBrand}
        labels={this.productGridItemLabels}
        isShowBrandNameEnabled={true}
        primaryBrand={primaryBrand || alternateBrand}
        isSearchListing={isSearchListing}
        isRecommendation={isRecommendation}
        isBopisFilterOn={isBopisFilterOn}
        categoryIdToCheck={categoryIdToCheck}
        setCurrentCategoryIdActn={setCurrentCategoryIdActn}
        isFromPLPPage={isFromPLPPage}
      />
    );
  };

  /* function to get product price section */

  getProductPriceSection = (listPriceForColor, offerPriceForColor, badge3) => {
    const {
      item,
      currencyAttributes,
      showPriceRange,
      theme,
      isHideOriginalPriceAndMarchantTagEnabled,
      isTileRedesignAB,
      setPLPSLPAddToCartCTA,
      isFavPage,
    } = this.props;
    const bundleProduct = item && item.productInfo && item.productInfo.bundleProduct;
    const isHardMarkDown = item && item.productInfo && item.productInfo.hardMarkDown;
    let priceRange = item && item.productInfo && item.productInfo.priceRange;
    if (priceRange && currencyAttributes && currencyAttributes.exchangevalue) {
      priceRange = {
        highListPrice: currencyConversion(priceRange.highListPrice, currencyAttributes),
        highOfferPrice: currencyConversion(priceRange.highOfferPrice, currencyAttributes),
        lowListPrice: currencyConversion(priceRange.lowListPrice, currencyAttributes),
        lowOfferPrice: currencyConversion(priceRange.lowOfferPrice, currencyAttributes),
      };
    }
    const badge3Text = listPriceForColor - offerPriceForColor !== 0 ? badge3 : '';
    const { isFavoriteView, isSuggestedItem } = this.props;
    const displayPriceRange = this.getDisplayPriceRange(showPriceRange, isFavoriteView, priceRange);
    const isHideOriginalPrice = hideProductOriginalPrice(
      isHardMarkDown,
      isHideOriginalPriceAndMarchantTagEnabled
    );
    return (
      <>
        {!isFavPage && (
          <StyledFavoriteEditItemButton
            theme={theme}
            isItemView={isFavoriteView || isSuggestedItem}
          />
        )}

        <ProductPricesSection
          listPrice={listPriceForColor}
          offerPrice={offerPriceForColor}
          noMerchantBadge={badge3}
          merchantTag={badge3Text}
          hidePrefixListPrice
          bundleProduct={bundleProduct}
          priceRange={priceRange}
          showPriceRange={displayPriceRange}
          isHideOriginalPrice={isHideOriginalPrice}
          isTileRedesignAB={isTileRedesignAB}
          isFavoriteView={isFavoriteView}
          setPLPSLPAddToCartCTA={setPLPSLPAddToCartCTA}
          isFavPage={isFavPage}
        />
      </>
    );
  };

  /* function to return promotional message component */
  getPromotionalMessageComponent = (
    promotionalMessage,
    promotionalPLCCMessage,
    renderWrapper = false
  ) => {
    const { isPlcc, isInternationalShipping, compactView } = this.props;
    if (compactView) return null;
    const text = getPromotionalMessage(isPlcc, {
      promotionalMessage,
      promotionalPLCCMessage,
    });
    if (!(text && !isInternationalShipping && !isCanada())) return null;
    const promotionalMsg = (
      <PromotionalMessage isInternationalShipping={isInternationalShipping} text={text} />
    );

    return renderWrapper ? (
      <div className="plp-new-promotion-wrapper">{promotionalMsg}</div>
    ) : (
      promotionalMsg
    );
  };

  openMoveItem = () => {
    this.setState((prevState) => ({
      isMoveItemOpen: !prevState.isMoveItemOpen,
    }));
  };

  handleChangeColor = (colorProductId) => {
    const { pdpUrl } = this.state;
    /**
     * Check if pdp url contains "_" then replace any "-" with "_" if not then vice versa.
     * So that the PDP URL changes correctly when color change in PLP page
     */
    const replaceObj =
      pdpUrl.indexOf('_') > 0
        ? { searchvalue: '-', newvalue: '_' }
        : { searchvalue: '_', newvalue: '-' };
    const { searchvalue, newvalue } = replaceObj;
    const { selectedColorProductId } = this.state;
    const color = selectedColorProductId.replace(searchvalue, newvalue);
    const selectedColor = colorProductId.replace(searchvalue, newvalue);
    this.onQuickViewOpenClick({
      colorProductId: selectedColor,
    });
    // eslint-disable-next-line react/destructuring-assignment
    this.state.pdpUrl = this.state.pdpUrl.replace(color, selectedColor);
  };

  getRecIdentifier = () => {
    let portalValue = null;
    const {
      page,
      variation = '',
      variations = '',
      moduleOHeaderLabel = '',
      modulePHeaderLabel = '',
    } = this.props;
    const moduleName = variation || variations || '';
    if (moduleName.includes('moduleO')) {
      portalValue = moduleOHeaderLabel;
    } else if (moduleName.includes('moduleP')) {
      portalValue = modulePHeaderLabel;
    }
    const recIdentifier = RecommendationsAbstractor.handleWhichRecommendationClicked(
      portalValue,
      page
    );
    return recIdentifier && recIdentifier.length ? recIdentifier : '';
  };

  categoryIdAndName = () => {
    const { item, categoryId = '', router = null } = this.props;
    const exactCategoryPath =
      (categoryId &&
        item.categoryPath2_catMap &&
        item.categoryPath2_catMap?.filter((categoryPath) => categoryPath.includes(categoryId))) ||
      '';
    return router?.query?.searchQuery
      ? router.query.searchQuery
      : `${item.miscInfo.categoryId}|${item.miscInfo.categoryName}` ||
          (exactCategoryPath && getCategoryIdAndName(exactCategoryPath)) ||
          '';
  };

  trackClickOnATB = () => {
    const { trackAnalyticsClick } = this.props;
    const recIdentifier = this.getRecIdentifier();
    if (recIdentifier) trackAnalyticsClick({ customEvents: ['event43'], metric43: '1' });
  };

  callAnalyticsOnAddToBagclick = () => {
    const { page, item, position, acrossBrandApiCalled, alternateBrandsShown } = this.props;
    if (!page) return;
    const recIdentifier = this.getRecIdentifier();
    const recAcronym = this.getRecAcronym();
    const pageAcronym = getStringAcronym(page || '');
    const categoryIdAndName = this.categoryIdAndName();
    const currentSiteBrand = getBrandInCaps();
    const cd66 = item?.dimension66
      ? { dimension66: `${item?.dimension66}|position-${position + 1}` }
      : '';
    const cd122 = acrossBrandApiCalled
      ? { dimension122: `${currentSiteBrand}>${alternateBrandsShown?.toUpperCase()}|null search` }
      : '';
    const args = {
      eventName: 'productDetail',
      eventType: 'detail',
      pageName: page,
      eventLabel: 'quick view product detail',
      productsObj: [
        {
          id: item.productInfo.generalProductId,
          price: item.productInfo.offerPrice,
          name: item.productInfo.name,
          brand: currentSiteBrand,
          category: recIdentifier
            ? `${DIMENSION92_TEXT}${pageAcronym}-${recAcronym}`
            : categoryIdAndName,
          dimension20: item.productInfo.generalProductId,
          dimension21: page,
          dimension35: currentSiteBrand,
          dimension80: recIdentifier
            ? `${DIMENSION92_TEXT}${pageAcronym}-${recAcronym}`
            : categoryIdAndName,
          dimension89: item.productInfo.generalProductId,
          dimension92: recIdentifier ? `${DIMENSION92_TEXT}${pageAcronym}-${recAcronym}` : '',
          dimension2: recIdentifier
            ? Constants.RECOMMENDATIONS_PAGES_MAPPING.RECOMMENDATIONS
            : 'browse',
          metric50: '1',
          ...cd66,
          ...cd122,
        },
      ],
    };

    fireEnhancedEcomm(args);
  };

  onQuickViewOpenClick = (payload) => {
    const { onQuickViewOpenClick } = this.props;
    onQuickViewOpenClick(payload);
  };

  checkIfOneClickATCEnabled = ({
    isSearchPage,
    isOneClickATCEnabled,
    variantDetails,
    isBopisFilterOn,
    tcpStyleType,
    customizationType,
  }) => {
    return (
      isSearchPage &&
      isOneClickATCEnabled &&
      variantDetails &&
      !isBopisFilterOn &&
      !isShopThisStoreModeOn() &&
      tcpStyleType !== '0007' &&
      customizationType !== 'mandatory'
    );
  };

  getProductPayload = (
    uniqueId,
    primaryBrand,
    item,
    name,
    offerPrice,
    colorName,
    topBadge,
    parsedVariantDetails
  ) => {
    const currency = getAPIConfig()?.currency;
    return {
      id: uniqueId,
      CurrCurrency: currency,
      primaryBrand,
      categoryId: uniqueId,
      cartPrice: item?.productInfo?.priceRange?.lowOfferPrice,
      colorId: item?.colorsMap?.[0]?.colorProductId,
      name,
      price: offerPrice,
      prodColor: colorName,
      quantity: 1,
      productFeatures: item?.productInfo?.shortDescription,
      listPrice: item?.productInfo?.listPrice,
      isOnlineExclusive: topBadge || null,
      originPage: 'slp',
      fromPage: 'search',
      size: parsedVariantDetails?.size,
      dimension2: 'search|one click atc',
      rating: item?.productInfo?.ratings,
    };
  };

  triggerOneClickATC = () => {
    const {
      isBopisFilterOn,
      isSearchPage,
      isOneClickATCEnabled,
      item,
      addToBagEcom,
      isMatchingFamily,
    } = this.props;
    const {
      productInfo: {
        variantDetails,
        tcpStyleType,
        tcpStyleQty,
        name,
        listPrice,
        offerPrice,
        seoToken,
        isGiftCard,
        uniqueId,
        primaryBrand,
      } = {},
      accessoriesData: { customizationType } = {},
      colorsMap,
      imagesByColor,
    } = item;

    if (
      this.checkIfOneClickATCEnabled({
        isSearchPage,
        isOneClickATCEnabled,
        variantDetails,
        isBopisFilterOn,
        tcpStyleType,
        customizationType,
      })
    ) {
      const parsedVariantDetails = getParsedVariantDetails(variantDetails);
      if (parsedVariantDetails) {
        const topBadge = getTopBadge(isMatchingFamily, colorsMap?.[0]?.miscInfo?.badge1);
        const colorName = colorsMap?.[0]?.color?.name;
        const fromAtc = true;
        const cd2 = 'search|one click atc';
        const payload = getPayloadForOneClickATC({
          name,
          isGiftCard,
          parsedVariantDetails,
          basicImageUrl: imagesByColor?.[colorName]?.basicImageUrl,
          seoToken,
          productId: uniqueId,
          TCPStyleType: tcpStyleType,
          TCPStyleQTY: tcpStyleQty,
          listPrice,
          offerPrice,
          TCPWebOnlyFlagStore: colorsMap?.[0]?.miscInfo?.isOnline,
          TCPProductIndStore: colorsMap?.[0]?.miscInfo?.isClearance,
          prodPartNo: uniqueId,
          brand: primaryBrand,
          topBadge,
          bossDisabledFlags: colorsMap?.[0]?.miscInfo?.bossDisabledFlags,
          colorName,
          item,
        });
        // For QG rerun
        payload.tileData = this.getProductPayload(
          uniqueId,
          primaryBrand,
          item,
          name,
          offerPrice,
          colorName,
          topBadge,
          parsedVariantDetails
        );
        payload.cd2 = cd2;
        payload.fromAtc = fromAtc;
        addToBagEcom(payload);
        return true;
      }
    }
    return false;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  handleQuickViewOpenClick = async (e) => {
    const {
      isSuggestedItem,
      onReplaceWishlistItem,
      activeWishListId,
      suggestedOOSItemId,
      item,
      addToBagEcom,
      isFavoriteView,
      page,
      position,
      resetSlpLoadingState,
      alternateBrandsShown,
      acrossBrandApiCalled,
    } = this.props;
    await AddedtoBagDynamicStore();
    if (acrossBrandApiCalled) {
      resetSlpLoadingState({ alternateBrandName: alternateBrandsShown });
    }
    if (e) {
      e.preventDefault();
    }
    const {
      productInfo: { generalProductId },
      skuInfo: { skuId, size } = {},
      itemInfo: { brand } = {},
    } = item;
    const { selectedColorProductId } = this.state;
    const cd66 = item?.dimension66
      ? { dimension66: `${item?.dimension66}|position-${position + 1}` }
      : '';
    if (item?.dimension66) {
      const { trackAnalyticsClick } = this.props;
      trackAnalyticsClick({
        customEvents: ['event66', 'event63'],
        metric63: '1',
        evar66: cd66?.dimension66,
      });
    }

    if (this.triggerOneClickATC()) {
      return;
    }

    if (isSuggestedItem && onReplaceWishlistItem) {
      const formData = {
        activeWishListId,
        itemId: suggestedOOSItemId,
        colorProductId: generalProductId,
      };
      onReplaceWishlistItem(formData);
    } else if (isFavoriteView) {
      // const brand = getBrandInCaps();
      const orderInfo = {
        itemBrand: brand,
      };
      if (skuId && size) {
        let cartItemInfo = getCartItemInfo(item, {});
        cartItemInfo = { ...cartItemInfo, brand, fromFavorites: true };
        if (addToBagEcom) addToBagEcom(cartItemInfo);
      } else {
        this.onQuickViewOpenClick({
          colorProductId: skuId,
          orderInfo,
          fromPage: page,
        });
      }
    } else {
      this.onQuickViewOpenClick({
        colorProductId: selectedColorProductId,
        fromPage: page,
        ...cd66,
      });
    }
    this.callAnalyticsOnAddToBagclick();
    this.trackClickOnATB();
  };

  handleViewBundleClick = (e) => {
    const {
      isBundleProductABTest,
      item: {
        productInfo: { bundleProduct, pdpUrl },
      },
      alternateBrand,
      acrossBrandApiCalled,
      resetSlpLoadingState,
      alternateBrandsShown,
    } = this.props;
    if (acrossBrandApiCalled) {
      resetSlpLoadingState({ alternateBrandName: alternateBrandsShown });
    }

    const isBundleProduct = !isBundleProductABTest && bundleProduct;
    const newPdpUrl = alternateBrand ? `${pdpUrl}$brand=${alternateBrand}` : pdpUrl;
    if (isBundleProduct && pdpUrl) {
      routerPush(pdpUrl.replace('b/', 'b?bid='), newPdpUrl);
    } else {
      this.handleQuickViewOpenClick(e);
    }
  };

  renderMoveItem = (itemId) => {
    const {
      wishlistsSummaries,
      createNewWishList,
      createNewWishListMoveItem,
      gridIndex,
      openAddNewList,
      activeWishListId,
      favoriteErrorMessages,
      isLoggedIn,
      theme,
    } = this.props;
    const { isMoveItemOpen } = this.state;
    const accordianIcon = isMoveItemOpen
      ? getIconPath('up_arrow_icon')
      : getIconPath('down_arrow_icon');
    return (
      isLoggedIn &&
      wishlistsSummaries && (
        <StyledMoveItemContainer>
          <StyledMoveItemButton
            className="move-item-button"
            onClick={this.openMoveItem}
            theme={theme}
          >
            {renderLabel(this.favLabels.lbl_fav_moveToAnotherList, 'lbl_fav_moveToAnotherList')}
            <StyledAccordianItemArrow
              alt="accordian button"
              className="icon-small"
              src={accordianIcon}
              data-locator="accordian-icon"
              height="6px"
            />
          </StyledMoveItemButton>
          {isMoveItemOpen && (
            <StyledMoveItemSection
              theme={theme}
              className={`item__${gridIndex % 2 ? 'even' : 'odd'} move-item-section`}
            >
              <CreateWishList
                wishlistsSummaries={wishlistsSummaries}
                createNewWishList={createNewWishList}
                createNewWishListMoveItem={createNewWishListMoveItem}
                itemId={itemId}
                gridIndex={gridIndex}
                openAddNewList={openAddNewList}
                activeWishListId={activeWishListId}
                favoriteErrorMessages={favoriteErrorMessages}
              />
            </StyledMoveItemSection>
          )}
        </StyledMoveItemContainer>
      )
    );
  };

  onSeeSuggestedHandler = (itemId) => {
    const {
      item: { skuInfo },
      onSeeSuggestedItems,
    } = this.props;

    const { colorProductId } = skuInfo;

    if (colorProductId && onSeeSuggestedItems) {
      onSeeSuggestedItems(colorProductId, itemId);
    }
  };

  SeeSuggestedList = (itemId) => {
    const { theme } = this.props;

    return (
      <StyledMoveItemContainer>
        <StyledMoveItemButton
          theme={theme}
          className="move-item-button"
          onClick={() => this.onSeeSuggestedHandler(itemId)}
        >
          <StyledSeeSuggestedItem
            fontFamily="secondary"
            fontSize={['fs10', 'fs12', 'fs14']}
            color="gray.900"
          >
            {renderLabel(
              getDynamicLabelValues('dynamic.browse_d.lbl_see_suggested_items'),
              'lbl_see_suggested_items'
            )}
          </StyledSeeSuggestedItem>
        </StyledMoveItemButton>
      </StyledMoveItemContainer>
    );
  };

  renderAddToBagLabel = (isBundleProduct, keepAlive) => {
    const outOfStockCapsLabels = renderLabel(
      this.commmonBrowseLabels.lbl_common_outOfStockCaps,
      'lbl_common_outOfStockCaps'
    );
    const { isSuggestedItem, isBopisFilterOn, isHorizontalPLPCarouselEnabled } = this.props;
    let addToBagLabel = '';
    if (isSuggestedItem) {
      addToBagLabel = this.lblPlpTiles && this.lblPlpTiles.lbl_add_to_favorites;
    } else if (isBundleProduct) {
      addToBagLabel = isGymboree()
        ? renderLabel(this.productGridItemLabels.shopthelook, 'lbl_plpTiles_shop_the_look')
        : renderLabel(this.productGridItemLabels.shopCollection, 'lbl_plpTiles_shop_collection');
    } else {
      addToBagLabel = renderLabel(this.productGridItemLabels.addToBag, 'lbl_add_to_bag');
    }
    if (isBopisFilterOn && !isHorizontalPLPCarouselEnabled) {
      addToBagLabel =
        (this.productGridItemLabels && this.productGridItemLabels.pickupInStore) ||
        'PICK UP IN STORE';
    }
    return keepAlive ? outOfStockCapsLabels : addToBagLabel;
  };

  errorMsgDisplay = () => {
    const {
      errorMessages,
      AddToFavoriteErrorMsg,
      item: {
        productInfo: { generalProductId },
      },
    } = this.props;
    const errorMsg = errorMessages && errorMessages[generalProductId];

    return errorMsg && errorMsg.itemId === generalProductId && AddToFavoriteErrorMsg ? (
      <Notification
        status="error"
        colSize={{ large: 12, medium: 8, small: 6 }}
        message={AddToFavoriteErrorMsg}
      />
    ) : null;
  };

  renderSuggestedError = (
    hasSuggestedProduct,
    suggestedProductErrors,
    generalProductId,
    item,
    isFavoriteView
  ) => {
    if (!isFavoriteView) {
      return false;
    }

    if (!item.skuInfo) {
      return false;
    }
    const {
      skuInfo: { colorProductId },
    } = item;

    if (!colorProductId) {
      return null;
    }
    const errorLabel = renderLabel(
      this.favLabels.lbl_fav_see_suggested_exception,
      'lbl_fav_see_suggested_exception'
    );
    return !hasSuggestedProduct &&
      colorProductId &&
      suggestedProductErrors &&
      suggestedProductErrors === colorProductId ? (
      // eslint-disable-next-line react/jsx-indent
      <Notification
        status="error"
        colSize={{ large: 12, medium: 8, small: 6 }}
        message={errorLabel}
      />
    ) : null;
  };

  getColorMiscInfo = (curentColorEntry) => {
    return (
      (curentColorEntry &&
        (this.colorsExtraInfo[curentColorEntry.color.name] || curentColorEntry.miscInfo)) ||
      {}
    );
  };

  onkeyPress = (e) => {
    const {
      item: {
        productInfo: { bundleProduct },
      },
      isShowQuickView,
    } = this.props;
    const isBundleProduct = bundleProduct;
    const { KEY_ENTER, KEY_SPACE } = KEY_CODES;
    if (e.keyCode === KEY_ENTER || e.keyCode === KEY_SPACE) {
      e.preventDefault();
      if (isShowQuickView && !isBundleProduct) {
        this.handleQuickViewOpenClick();
      } else {
        this.handleViewBundleClick();
      }
    }
  };

  evalSetPLPSLPAddToCartCTA = (
    isHidePLPAddToBag,
    setPLPSLPAddToCartCTA,
    isShowQuickView,
    isBundleProduct,
    isSLP,
    isFavPage
  ) => {
    let res;

    if (isHidePLPAddToBag || (setPLPSLPAddToCartCTA === 'hidden' && isSLP === true)) {
      res = '';
    }
    if ((setPLPSLPAddToCartCTA === 'icon' && isSLP === true) || isFavPage) {
      res = (
        <AtbIcon
          onClick={
            // same as below button
            isShowQuickView && !isBundleProduct
              ? this.handleQuickViewOpenClick
              : this.handleViewBundleClick
          }
        >
          <img src={getIconPath('add-to-bag-icon-blue')} alt="Add to bag" />
        </AtbIcon>
      );
    }
    return res;
  };

  // Helper function to handle the click event for the button
  handleButtonClick = (isShowQuickView, bundleProduct) => {
    setTimeout(() => {
      if (isShowQuickView && !bundleProduct) {
        this.handleQuickViewOpenClick();
      } else {
        this.handleViewBundleClick();
      }
    }, 0);
  };

  renderSubmitButton = (keepAlive, itemNotAvailable, isHidePLPAddToBag) => {
    // DRP-43: Kill Switch to hide Add to Bag CTA on PLP and SLP.
    // Added this condition here, as main render method is reaching higher complexity
    // Hide when response is false
    const {
      theme,
      item: {
        itemInfo: { itemId } = {},
        productInfo: { bundleProduct, generalProductId, name },
      },
      removeFavItem,
      isFavoriteView,
      isShowQuickView,
      AddToFavoriteErrorMsg,
      item,
      isNewPLPImageBorderEnabled,
      isNewPLPAtbCardTileEnabled,
      isSLP,
      setPLPSLPAddToCartCTA,
      isFavPage,
    } = this.props;
    const { errorProductId } = this.state;
    const fulfilmentSection =
      AddToFavoriteErrorMsg && errorProductId === generalProductId ? '' : 'fulfillment-section';
    const ATBSpacingClass = isSLP ? ' atb-button-slp-spacing' : '';
    const buttonFillFavView = isFavoriteView ? FAVORITES_VIEW_BUTTON_FILL[getBrandInCaps()] : '';
    const buttonFill = isPJP() ? 'PJP_PRIMARY' : buttonFillFavView;
    if ((setPLPSLPAddToCartCTA !== 'off' && isSLP === true) || (isFavPage && !itemNotAvailable)) {
      return this.evalSetPLPSLPAddToCartCTA(
        isHidePLPAddToBag,
        setPLPSLPAddToCartCTA,
        isShowQuickView,
        bundleProduct,
        isSLP,
        isFavPage
      );
    }

    return itemNotAvailable ? (
      <Anchor
        className={`remove-favorite${ATBSpacingClass} remove-fav-item__button`}
        handleLinkClick={(event) => {
          event.preventDefault();
          removeFavItem({ itemId, products: item.productInfo });
        }}
        noLink
      >
        {renderLabel(
          getLabelFromCopyOrFromTranslation(
            `${GLOBAL_ACTIONS_LABELS}.${lblRemove}`,
            GlobalActionsLabels
          )
        )}
      </Anchor>
    ) : (
      <div className={fulfilmentSection}>
        <StyledAddToBagButton
          theme={theme}
          item={item}
          className="added-to-bag"
          id={`brand-${getBrand()}`}
          fullWidth
          buttonVariation="fixed-width"
          dataLocator={getLocator('global_addtocart_Button')}
          onClick={() => this.handleButtonClick(isShowQuickView, bundleProduct)}
          onKeyUp={this.onkeyPress}
          disabled={keepAlive}
          fill={buttonFill}
          isFavoriteView={isFavoriteView}
          ariaLabel={`${this.renderAddToBagLabel(bundleProduct, keepAlive)} ${name}`}
          isNewPLPImageBorderEnabled={isNewPLPImageBorderEnabled}
          isNewPLPAtbCardTileEnabled={isNewPLPAtbCardTileEnabled}
          isSLP={isSLP}
        >
          {this.renderAddToBagLabel(bundleProduct, keepAlive)}
        </StyledAddToBagButton>
      </div>
    );
  };

  getIsProductBrandSameDomain = () => {
    const { item } = this.props;
    const currentSiteBrand = getBrandInCaps();
    const itemBrand = item?.itemInfo?.brand ? item.itemInfo.brand.toUpperCase() : currentSiteBrand;
    return currentSiteBrand === itemBrand;
  };

  renderFavouriteIcon = ({
    bundleProduct,
    isFavoriteView,
    isInDefaultWishlist,
    itemNotAvailable,
    isSuggestedItem,
    isFavPage,
    fromBuyItAgain,
    isSLP,
    guestAccessKey,
  }) => {
    const { compactView } = this.props;
    const handleAddRemoveFromWishlistObj = {
      handleAddToWishlist: this.handleAddToWishlist,
      handleRemoveFromWishList: this.handleRemoveFromWishList,
    };
    return (
      !bundleProduct &&
      !compactView &&
      WishListIcon({
        isFavoriteView,
        isInDefaultWishlist,
        handleAddRemoveFromWishlistObj,
        itemNotAvailable,
        favoritedCount: '',
        isSuggestedItem,
        lblPlpTiles: this.lblPlpTiles,
        isFavPage,
        isNewFavIcon: true,
        fromBuyItAgain,
        isSLP,
        isDisabled: guestAccessKey,
      })
    );
  };

  renderProductTitle = ({
    name,
    pdpUrl,
    loadedProductCount,
    viaModule,
    analyticsData,
    isProductBrandOfSameDomain,
    isSearchPage,
    page,
    isSoldOut,
    cookieToken,
    bundleProduct,
    dataSource,
    googleAnalyticsData,
    primaryBrand,
    isSNJEnabled,
    isNewPDPEnabled,
    categoryIdToCheck,
    setCurrentCategoryIdActn,
    isFromPLPPage,
    badge2,
    isMountedTileRedesignAB,
    TCPPrimaryCategory,
  }) => {
    const {
      compactView,
      alternateBrand,
      labels,
      isShowBrandNameEnabled,
      isSearchListing,
      isRecommendation,
      isBopisFilterOn,
      isRecommendationProductInfoEnabled,
      isCrossBrandMerchandisingEnabled,
      isFavoriteView,
      useRouterNavigation,
    } = this.props;
    return !compactView ||
      (isSNJEnabled && isNewPDPEnabled && !isRecommendationProductInfoEnabled) ? (
      <ProductTitle
        name={name}
        pdpUrl={pdpUrl}
        loadedProductCount={loadedProductCount}
        viaModule={viaModule}
        dataSource={dataSource}
        analyticsData={analyticsData}
        isProductBrandOfSameDomain={isProductBrandOfSameDomain}
        isSearchPage={isSearchPage}
        page={page}
        isSoldOut={isSoldOut}
        cookieToken={cookieToken}
        bundleProduct={bundleProduct}
        googleAnalyticsData={googleAnalyticsData}
        alternateBrand={alternateBrand}
        labels={labels}
        isShowBrandNameEnabled={isShowBrandNameEnabled}
        primaryBrand={primaryBrand || alternateBrand}
        isSearchListing={isSearchListing}
        isRecommendation={isRecommendation}
        isBopisFilterOn={isBopisFilterOn}
        categoryIdToCheck={categoryIdToCheck}
        setCurrentCategoryIdActn={setCurrentCategoryIdActn}
        isFromPLPPage={isFromPLPPage}
        isCrossBrandMerchandisingEnabled={isCrossBrandMerchandisingEnabled}
        isFavoriteView={isFavoriteView}
        badge2={badge2}
        isMountedTileRedesignAB={isMountedTileRedesignAB}
        TCPPrimaryCategory={TCPPrimaryCategory}
        useRouterNavigation={useRouterNavigation}
      />
    ) : null;
  };

  renderTopRatedBadgeItem = () => {
    const { theme } = this.props;

    return (
      <CustomBadge
        type={TOP_RATED}
        theme={theme}
        text={renderLabel(
          this.productGridItemLabels.topRatedBadgeLabel,
          'lbl_TCPBazaarVoiceRating'
        )}
        customFontWeight="bold"
        customFontSize={['fs8', 'fs8', 'fs10']}
      />
    );
  };

  renderBestSellerBadgeItem = () => {
    const { theme } = this.props;

    return (
      <CustomBadge
        type={BEST_SELLER}
        theme={theme}
        text={renderLabel(this.productGridItemLabels.bestSellerBadgeLabel, 'lbl_best_seller')}
        customFontWeight="bold"
        customFontSize={['fs8', 'fs8', 'fs10']}
      />
    );
  };

  renderMostFavoritedBadgeItem = () => {
    const { theme } = this.props;

    return (
      <CustomBadge
        type={MOST_FAVORITED}
        theme={theme}
        text={renderLabel(this.productGridItemLabels.mostFavoritedBadgeLabel, 'lbl_favoritedcount')}
        customFontWeight="bold"
        customFontSize={['fs8', 'fs8', 'fs10']}
      />
    );
  };

  renderBadgeItem = (isShowBadges, topBadge) => {
    const { isSuggestedItem, isFavoriteView, compactView, theme } = this.props;
    return !isSuggestedItem && !isFavoriteView && !compactView ? (
      <StyledTopBadgeContainer
        theme={theme}
        isShowBadges={isShowBadges}
        text={topBadge}
        haveSpace
      />
    ) : null;
  };

  renderInfluencerPick = (isShowBadges, influencerPick) => {
    const { isSuggestedItem, compactView, theme } = this.props;
    return !isSuggestedItem && !compactView ? (
      <StyledInfluencerPickBadgeContainer
        theme={theme}
        isShowBadges={isShowBadges}
        text={influencerPick?.toUpperCase()}
        haveSpace
      />
    ) : null;
  };

  renderBadge = ({
    inGridPlpRecommendation,
    influencerPicks,
    isShowBadges,
    topBadge,
    isFavPage,
    isInfluencerPicksEnabled,
  }) => {
    if (!inGridPlpRecommendation) {
      if (influencerPicks && isInfluencerPicksEnabled) {
        return this.renderInfluencerPick(isShowBadges, influencerPicks[0]);
      }
      return isFavPage && isInfluencerPicksEnabled ? (
        <div className="badge-container" />
      ) : (
        this.renderBadgeItem(isShowBadges, topBadge)
      );
    }
    return null;
  };

  renderTopBadge = ({
    inGridPlpRecommendation,
    influencerPicks,
    isShowBadges,
    topBadge,
    isFavPage,
    isInfluencerPicksEnabled,
    isSLP,
    isMountedTileRedesignAB,
    zoneOneBadgesArray,
  }) => {
    if (isSLP && isMountedTileRedesignAB) {
      if (zoneOneBadgesArray.length > 0) {
        return (
          <ZoneOneBadgesWrapper className={'zone-one-badges-wrapper'}>
            {zoneOneBadgesArray.map((badge) => {
              return (
                <ZoneOneBadges
                  key={badge.priority.toString()}
                  type={badge.type}
                  text={badge.label}
                />
              );
            })}
          </ZoneOneBadgesWrapper>
        );
      }
      return <ZoneOneBadgesWrapper />;
    }

    return (
      <div className="slp-inner-container-inline">
        {this.renderBadge({
          inGridPlpRecommendation,
          influencerPicks,
          isShowBadges,
          topBadge,
          isFavPage,
          isInfluencerPicksEnabled,
        })}
      </div>
    );
  };

  renderBadgeTwo = (badge2, useCol = true) => {
    const { isSuggestedItem, isFavoriteView, compactView, isNewPLPAtbCardTileEnabled } = this.props;
    return useCol ? (
      <Col colSize={{ small: 12 }} className="extended-sizes-text-wrapper">
        <StyledExtendedSizeText
          dataLocator={getLocator('global_Extended_sizes_text')}
          fontWeight="extrabold"
          fontFamily="secondary"
          fontSize={['fs10', 'fs12', 'fs14']}
          className="extended-sizes-text elem-mb-SM"
          isNewPLPAtbCardTileEnabled={isNewPLPAtbCardTileEnabled}
        >
          {!isSuggestedItem && !isFavoriteView && !compactView && badge2
            ? badge2.toUpperCase()
            : ''}
        </StyledExtendedSizeText>
      </Col>
    ) : (
      <div className="extended-sizes-text-wrapper">
        <StyledExtendedSizeText
          dataLocator={getLocator('global_Extended_sizes_text')}
          fontWeight="extrabold"
          fontFamily="secondary"
          fontSize={['fs10', 'fs12', 'fs14']}
          className="extended-sizes-text elem-mb-SM"
          isNewPLPAtbCardTileEnabled={isNewPLPAtbCardTileEnabled}
        >
          {!isSuggestedItem && !isFavoriteView && !compactView && badge2
            ? badge2.toUpperCase()
            : ''}
        </StyledExtendedSizeText>
      </div>
    );
  };

  checkBrand = (isTCP) => {
    if (typeof isTCP === 'boolean' && isTCP) {
      return 'TCP';
    }
    if (typeof isTCP === 'boolean' && !isTCP) {
      return 'GYM';
    }
    return false;
  };

  getPriceForProduct = (listPrice, offerPrice, currencyAttributes) => {
    let listPriceForColor = listPrice;
    let offerPriceForColor = offerPrice;
    if (currencyAttributes && currencyAttributes.exchangevalue) {
      listPriceForColor = currencyConversion(listPrice, currencyAttributes);
      offerPriceForColor = currencyConversion(offerPrice, currencyAttributes);
    }
    return {
      listPriceForColor,
      offerPriceForColor,
    };
  };

  getCategoryName = (breadCrumbs, isSearchPage) => {
    if (isSearchPage) {
      const searchRedirect = getSearchRedirectObj();
      return searchRedirect && searchRedirect.pc ? searchRedirect.pc : 'apparel';
    }
    return getProductCategory(breadCrumbs);
  };

  getRecAcronym = () => {
    const recIdentifier = this.getRecIdentifier();
    const recIdentifierMatch = (recIdentifier && recIdentifier.match(/\b(\w)/g)) || '';
    return (recIdentifierMatch && recIdentifierMatch.join('')) || '';
  };

  biaTrackCLickPDP = (cd66) => {
    const { pdpUrl } = this.state;
    const { trackAnalyticsClick } = this.props;
    trackAnalyticsClick({ customEvents: ['event63'], metric63: '1' });
    const cd66Item = JSON.stringify({
      dimension66: cd66,
      item: pdpUrl,
    });
    setSessionStorage({ key: 'biaDimension', value: cd66Item });
  };

  recommendationsTrackClickPDP = () => {
    const { trackAnalyticsClick } = this.props;
    const recIdentifier = this.getRecIdentifier();
    if (recIdentifier) trackAnalyticsClick({ customEvents: ['event41'], metric41: '1' });
  };

  updateGoogleAnalyticsData = () => {
    const {
      item,
      currencyAttributes,
      position,
      currencySymbol,
      page,
      isHideOriginalPriceAndMarchantTagEnabled,
    } = this.props;
    let color = '';
    item?.colorsMap?.forEach((c) => {
      if (c.colorProductId === item.productInfo.generalProductId) color = c.color.name;
    });
    const currentSiteBrand = getBrandInCaps();
    const currency = (currencyAttributes && currencyAttributes.id) || currencySymbol || '';
    const isSearchPage = isClient() && window.location.href.includes('/search/');
    const recIdentifier = this.getRecIdentifier();
    const recAcronym = this.getRecAcronym();
    const pageAcronym = getStringAcronym(page || '');
    const categoryIdAndName = this.categoryIdAndName();
    const cd66 = item?.dimension66 ? `${item?.dimension66}|position-${position + 1}` : '';
    const originalPrice = getOriginalPrice({
      hardMarkDown: item?.productInfo?.hardMarkDown,
      isHideOriginalPriceAndMarchantTagEnabled,
      listPrice: item?.productInfo?.listPrice,
      currency,
      addWhiteSpace: true,
    });

    const pr1cd92 = '1920';
    if (item?.dimension66) {
      this.biaTrackCLickPDP(cd66);
    }
    const args = {
      eventName: 'productclick',
      eventAction: 'Product Click',
      eventType: 'click',
      pageName: getGAPageName(),
      currCode: currency,
      eventLabel: 'Product detail',
      productsObj: [
        {
          name: item.productInfo.name,
          id: item.productInfo.generalProductId,
          price: item.productInfo.offerPrice,
          brand: currentSiteBrand,
          category: recIdentifier
            ? `${DIMENSION92_TEXT}${pageAcronym}-${recAcronym}`
            : categoryIdAndName,
          variant: color,
          position: isSearchPage ? position + 1 : position,
          dimension80: recIdentifier
            ? `${DIMENSION92_TEXT}${pageAcronym}-${recAcronym}`
            : categoryIdAndName,
          dimension67:
            item.productInfo.offerPrice < item.productInfo.listPrice ? 'on sale' : 'full price',
          dimension89: item.productInfo.generalProductId,
          dimension100: isSearchPage ? position + 1 : position,
          dimension63: `${item.productInfo.offerPrice} ${currency}: ${originalPrice}`,
          dimension77: color,
          dimension35: currentSiteBrand,
          dimension92: recIdentifier
            ? `${DIMENSION92_TEXT}${pageAcronym}-${recAcronym}-${pr1cd92}`
            : '',
          dimension21: page,
          ...cd66,
        },
      ],
    };
    pushEventToAdobeAnalytics('product_click', args?.productsObj?.[0]);
    fireEnhancedEcomm(args);
  };

  renderPointsAndReward = (renderWrapper = false) => {
    const { theme } = this.props;
    const pointsAndRewardsTextLabelVal = getDynamicLabelValues(
      'dynamic.browse_d.lbl_brierley_promo_text_generic_slp'
    );
    const pointsAndRewardsLabel =
      (pointsAndRewardsTextLabelVal && pointsAndRewardsTextLabelVal.split('##')) || '';
    if (!pointsAndRewardsLabel) return null;
    const pointsAndRewards = (
      <StyledPointsAndRewards className="points-and-rewards">
        {pointsAndRewardsLabel[0] && (
          <StyledPointsAndRewards1 theme={theme}>
            {pointsAndRewardsLabel[0]}
          </StyledPointsAndRewards1>
        )}
        {pointsAndRewardsLabel[1] && (
          <StyledPointsAndRewardsOr theme={theme}>
            {pointsAndRewardsLabel[1]}
          </StyledPointsAndRewardsOr>
        )}
        {pointsAndRewardsLabel[2] && (
          <StyledPointsAndRewards2 theme={theme}>
            {pointsAndRewardsLabel[2]}
          </StyledPointsAndRewards2>
        )}
      </StyledPointsAndRewards>
    );

    return renderWrapper ? (
      <div className="plp-new-promotion-wrapper">{pointsAndRewards}</div>
    ) : (
      pointsAndRewards
    );
  };

  getInGridRecommendation = () => {
    const { portalValue } = this.props;
    const label =
      portalValue === Constants.RECOMMENDATIONS_MBOXNAMES.IN_GRID_PLP_PRODUCTS
        ? renderLabel(this.productGridItemLabels.inGridDescription, 'lbl_plp_in_grid_description')
        : renderLabel(
            this.productGridItemLabels.inMultiGridDescription,
            'lbl_plp_in_multi_grid_description'
          );
    return (
      <div className="in-grid-plp-rectangle">
        <span>{label}</span>
      </div>
    );
  };

  renderFavoriteMovePurchaseSection = (itemNotAvailable, quantity, quantityPurchased, itemId) => {
    const {
      theme,
      isLoggedIn,
      onQuickViewOpenClick,
      isFavoriteView,
      item,
      keepAlive,
      isHidePLPAddToBag,
      setPLPSLPAddToCartCTA,
      isFavPage,
    } = this.props;
    const { selectedColorProductId } = this.state;
    if (itemNotAvailable)
      return (
        <StyledFavoriteMovePurchaseSection theme={theme} isFavPage={isFavPage}>
          {this.renderSubmitButton(
            keepAlive,
            itemNotAvailable,
            isHidePLPAddToBag,
            setPLPSLPAddToCartCTA
          )}
          {!isFavoriteView && this.SeeSuggestedList(itemId)}
        </StyledFavoriteMovePurchaseSection>
      );
    return (
      <StyledFavoriteMovePurchaseSection theme={theme} isFavPage={isFavPage}>
        {isLoggedIn &&
          EditButton(
            {
              onQuickViewOpenClick,
              isFavoriteView,
              productGridItemLabels: this.productGridItemLabels,
              item,
              globalActions: this.globalActions,
            },
            selectedColorProductId,
            itemNotAvailable
          )}
        {this.renderMoveItem(itemId)}
      </StyledFavoriteMovePurchaseSection>
    );
  };

  renderPromoMessage = (isAddedToBag, isRecommendation) => {
    const {
      isSearchListing,
      item: {
        productInfo: { primaryBrand, TCPPromotionID, TCPPromotionPrice },
      },
      alternateBrand,
      isTileRedesignAB,
      isPDP,
    } = this.props;
    return (
      <StyledPromotionWrapper isTileRedesignAB={isTileRedesignAB} isPDP={isPDP}>
        {!isAddedToBag ? (
          <Promotions
            showIcon
            isRecommendation={isRecommendation}
            className="isPLP"
            pageName={isSearchListing ? 'SLP' : 'PLP'}
            isTileRedesignAB={isTileRedesignAB}
            brand={primaryBrand || alternateBrand}
            TCPPromotionID={TCPPromotionID}
            TCPPromotionPrice={TCPPromotionPrice}
          />
        ) : null}
      </StyledPromotionWrapper>
    );
  };

  checkInWishlist = (wishList, productId) => {
    return wishList && wishList[productId] && wishList[productId].isInDefaultWishlist;
  };

  isPDP = () => {
    const { page } = this.props;
    return `${page === 'pdp' ? 'pdp' : ''}`;
  };

  renderZoneSixBadges = (zoneSixBadges) => {
    if (zoneSixBadges) {
      return <ZoneSixBadges text={zoneSixBadges} />;
    }
    return null;
  };

  validateFavPage = (itemNotAvailable) => {
    const { isFavPage } = this.props;

    if (isFavPage && itemNotAvailable) {
      return false;
    }
    return true;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  renderCardTile = (zoneSixBadges, isMountedTileRedesignAB, TCPPrimaryCategory) => {
    const {
      currencyAttributes,
      item,
      loadedProductCount,
      sqnNmbr,
      unbxdId,
      isFavoriteView,
      isSuggestedItem,
      viaModule,
      dataSource,
      isSearchPage,
      page,
      wishList,
      cookieToken,
      inGridPlpRecommendation,
      isBrierleyPromoEnabled,
      isSNJEnabled,
      isNewPDPEnabled,
      isATBModalBackAbTestNewDesign,
      currentCategoryId,
      categoryId,
      setCurrentCategoryIdActn,
      fromBuyItAgain,
      isNewPLPAtbCardTileEnabled,
      isAddedToBag,
      isRecommendation,
      keepAlive,
      setPLPSLPAddToCartCTA,
      isHidePLPAddToBag,
      isSLP,
      isFavPage,
      isTileRedesignAB,
      isRatingRedesignAbTest,
      guestAccessKey,
    } = this.props;

    const {
      miscInfo: { categoryId: categoryIdL3, isStoreSpecialEligible },
      productInfo: {
        bundleProduct,
        generalProductId,
        promotionalMessage,
        promotionalPLCCMessage,
        name,
        listPrice: itemListPrice,
        offerPrice: itemOfferPrice,
        primaryBrand,
        TCPPromotionPrice,
        TCPPromotionID,
      },
      itemInfo: { availability, brand } = {},
      colorsMap,
      lastPurchasedSize,
    } = item;

    const itemNotAvailable = availability === AVAILABILITY.SOLDOUT;
    const { selectedColorProductId, pdpUrl } = this.state;
    const curentColorEntry = getMapSliceForColorProductId(colorsMap, selectedColorProductId);
    const currentColorMiscInfo = this.getColorMiscInfo(curentColorEntry);
    const isInWishList = checkInWishlistUtil(wishList, selectedColorProductId);
    const {
      listPrice = itemListPrice,
      offerPrice = itemOfferPrice,
      badge2,
      badge3,
    } = currentColorMiscInfo;
    const isFromPLPPage = isClient() && window?.location?.href?.includes(SLASH_C_ROUTE);
    const categoryIdToCheck = currentCategoryId || categoryIdL3 || categoryId;
    const { listPriceForColor, offerPriceForColor } = this.getPriceForProduct(
      listPrice,
      offerPrice,
      currencyAttributes
    );
    const sqnNmb = sqnNmbr;
    const itemBrand = brand;
    const promotionalMessageModified = promotionalMessage || '';
    const promotionalPLCCMessageModified = promotionalPLCCMessage || '';

    const isProductBrandOfSameDomain = this.getIsProductBrandSameDomain();
    const googleAnalyticsData = this.updateGoogleAnalyticsData;

    return isNewPLPAtbCardTileEnabled ? (
      <div className="plp-new-product-tile">
        {isTileRedesignAB &&
          this.getColorChipContainer(curentColorEntry, itemBrand, pdpUrl, primaryBrand)}
        {(!isMountedTileRedesignAB || !isSLP) && (
          <div className="plp-new-extended-sizes">{this.renderBadgeTwo(badge2, false)}</div>
        )}
        {this.renderProductTitle({
          name,
          pdpUrl,
          loadedProductCount,
          viaModule,
          dataSource,
          analyticsData: {
            pId: generalProductId,
            prank: sqnNmb,
            requestId: unbxdId,
          },
          isProductBrandOfSameDomain,
          isSearchPage,
          page,
          isSoldOut: itemNotAvailable,
          cookieToken,
          bundleProduct,
          googleAnalyticsData,
          primaryBrand,
          isSNJEnabled,
          isNewPDPEnabled,
          categoryIdToCheck,
          setCurrentCategoryIdActn,
          isFromPLPPage,
          TCPPrimaryCategory,
        })}
        {this.renderSuggestedLabel()}
        {inGridPlpRecommendation && this.getInGridRecommendation()}
        {!isTileRedesignAB &&
          this.getColorChipContainer(curentColorEntry, itemBrand, pdpUrl, primaryBrand)}

        {setPLPSLPAddToCartCTA === 'icon' && isSLP ? (
          <div className="slp-inner-container-pjp">
            <div>{this.getProductPriceSection(listPriceForColor, offerPriceForColor, badge3)}</div>
            {this.renderSubmitButton(
              keepAlive,
              itemNotAvailable,
              isHidePLPAddToBag,
              setPLPSLPAddToCartCTA
            )}
          </div>
        ) : (
          this.getProductPriceSection(listPriceForColor, offerPriceForColor, badge3)
        )}
        {this.renderPromoMessage(
          isAddedToBag,
          isRecommendation || viaModule === Constants.RECOMMENDATION
        )}
        {isBrierleyPromoEnabled
          ? this.renderPointsAndReward(true)
          : !isSuggestedItem &&
            this.getPromotionalMessageComponent(
              promotionalMessageModified,
              promotionalPLCCMessageModified,
              true
            )}
        {!(isTileRedesignAB || isRatingRedesignAbTest) && this.renderCustomRatings()}
        {(isTileRedesignAB || isRatingRedesignAbTest) && this.renderCustomRatings()}
        {isMountedTileRedesignAB && isSLP && this.renderZoneSixBadges(zoneSixBadges)}
        <StoreSpecialMsg
          offerPrice={offerPrice}
          isStoreSpecialEligible={isStoreSpecialEligible}
          TCPPromotionPrice={TCPPromotionPrice}
          TCPPromotionID={TCPPromotionID}
        />
      </div>
    ) : (
      <>
        {isTileRedesignAB &&
          !isFavPage &&
          this.getColorChipContainer(curentColorEntry, itemBrand, pdpUrl, primaryBrand)}
        {(!isMountedTileRedesignAB || !isSLP) && !isFavPage && this.renderBadgeTwo(badge2)}
        {(setPLPSLPAddToCartCTA !== 'off' && isSLP === true) || isFavPage ? (
          <div className="slp-inner-container-inline">
            <Col colSize={{ small: 6, medium: 6, large: 10 }}>
              {this.getProductPriceSection(listPriceForColor, offerPriceForColor, badge3)}
              {isFavPage &&
                this.renderProductTitle({
                  name,
                  pdpUrl,
                  loadedProductCount,
                  viaModule,
                  dataSource,
                  analyticsData: {
                    pId: generalProductId,
                    prank: sqnNmb,
                    requestId: unbxdId,
                  },
                  isProductBrandOfSameDomain,
                  isSearchPage,
                  page,
                  isSoldOut: itemNotAvailable,
                  cookieToken,
                  bundleProduct,
                  googleAnalyticsData,
                  primaryBrand,
                  isSNJEnabled,
                  isATBModalBackAbTestNewDesign,
                  isNewPDPEnabled,
                  categoryIdToCheck,
                  setCurrentCategoryIdActn,
                  isFromPLPPage,
                  badge2,
                  isMountedTileRedesignAB,
                  TCPPrimaryCategory,
                })}
            </Col>
            <div className={isTileRedesignAB ? 'floating-atb-btn' : ''}>
              {this.validateFavPage(itemNotAvailable) &&
                this.renderSubmitButton(
                  keepAlive,
                  itemNotAvailable,
                  isHidePLPAddToBag,
                  setPLPSLPAddToCartCTA
                )}
            </div>
          </div>
        ) : (
          <Row fullBleed className="product-wishlist-container">
            <Col colSize={{ small: 4, medium: 6, large: 10 }}>
              {this.getProductPriceSection(listPriceForColor, offerPriceForColor, badge3)}
            </Col>
            {!isSLP &&
              this.renderFavouriteIcon({
                bundleProduct,
                isFavoriteView,
                isInDefaultWishlist: isInWishList,
                itemNotAvailable,
                isSuggestedItem,
                isFavPage,
                fromBuyItAgain,
                isSLP: false,
                guestAccessKey,
              })}
          </Row>
        )}
        {this.renderPromoMessage(
          isAddedToBag,
          isRecommendation || viaModule === Constants.RECOMMENDATION
        )}
        {!isFavPage &&
          this.renderProductTitle({
            name,
            pdpUrl,
            loadedProductCount,
            viaModule,
            dataSource,
            analyticsData: {
              pId: generalProductId,
              prank: sqnNmb,
              requestId: unbxdId,
            },
            isProductBrandOfSameDomain,
            isSearchPage,
            page,
            isSoldOut: itemNotAvailable,
            cookieToken,
            bundleProduct,
            googleAnalyticsData,
            primaryBrand,
            isSNJEnabled,
            isATBModalBackAbTestNewDesign,
            isNewPDPEnabled,
            categoryIdToCheck,
            setCurrentCategoryIdActn,
            isFromPLPPage,
            badge2,
            isMountedTileRedesignAB,
            TCPPrimaryCategory,
          })}
        {this.renderSuggestedLabel()}
        {inGridPlpRecommendation && this.getInGridRecommendation()}
        {!isTileRedesignAB &&
          !isFavPage &&
          this.getColorChipContainer(curentColorEntry, itemBrand, pdpUrl, primaryBrand)}
        {isBrierleyPromoEnabled
          ? this.renderPointsAndReward()
          : !isSuggestedItem &&
            this.getPromotionalMessageComponent(
              promotionalMessageModified,
              promotionalPLCCMessageModified
            )}
        {isNewPLPAtbCardTileEnabled && <StyledHorizontalRule />}
        {!(isTileRedesignAB || isRatingRedesignAbTest) && this.renderCustomRatings()}
        {(isTileRedesignAB || isRatingRedesignAbTest) && this.renderCustomRatings()}
        {lastPurchasedSize && (
          <BodyCopy
            component="div"
            fontSize={isMobileWeb() ? 'fs10' : 'fs12'}
            fontWeight="normal"
            fontFamily="secondary"
            color="gray.800"
            className={'elem-mb-XXS'}
          >{`Last Purchased ${lastPurchasedSize}`}</BodyCopy>
        )}
        {isMountedTileRedesignAB && isSLP && this.renderZoneSixBadges(zoneSixBadges)}
        <StoreSpecialMsg
          offerPrice={offerPrice}
          isStoreSpecialEligible={isStoreSpecialEligible}
          TCPPromotionPrice={TCPPromotionPrice}
          TCPPromotionID={TCPPromotionID}
        />
      </>
    );
  };

  renderDiscoveryButton = (SyteConfig) => {
    const { showDiscoveryIcon } = this.state;
    return (
      !isShopThisStoreModeOn() &&
      showDiscoveryIcon && (
        <div className="syte-container-wrapper">
          <DiscoveryButton config={SyteConfig}>
            <AnimatedSearchIcon
              iconLabel={renderLabel(this.productGridItemLabels.shopSimilar, 'lbl_shop_similar')}
              iconPath={getIconPath('cta-search')}
              reverseOrder
            />
          </DiscoveryButton>
        </div>
      )
    );
  };

  static contextType = LabelsContext;

  // eslint-disable-next-line complexity
  // eslint-disable-next-line sonarjs/cognitive-complexity
  render() {
    const {
      onQuickViewOpenClick,
      item,
      isOnModelAbTestPlp,
      isMatchingFamily,
      loadedProductCount,
      className,
      sqnNmbr,
      unbxdId,
      isFavoriteView,
      forwardedRef,
      isKeepAliveEnabled,
      isSuggestedItem,
      viaModule,
      dataSource,
      isSearchPage,
      page,
      isLoggedIn,
      cookieToken,
      isHidePLPAddToBag,
      hasSuggestedProduct,
      suggestedProductErrors,
      lowQualityEnabled,
      portalValue,
      inGridPlpRecommendation,
      widgetScrapeContentId,
      isSecureImageFlagEnabled,
      alternateBrand,
      isBopisFilterOn,
      theme,
      currentCategoryId,
      categoryId,
      setCurrentCategoryIdActn,
      isHorizontalPLPCarouselEnabled,
      isNewPLPImageBorderEnabled,
      trackAnalyticsClick,
      isPLPImageHeightBasedOnAspectRatio,
      preloadImage,
      isRecommendationProductInfoEnabled,
      isTopRatedBadgeEnabledSLP,
      isBestSellerBadgeEnabledSLP,
      isHomePage,
      isMostFavoritedBadgeEnabled,
      setPLPSLPAddToCartCTA,
      wishList,
      isSLP,
      isInfluencerBadgeEnabled,
      isFavPage,
      isInfluencerPicksEnabled,
      isTileRedesignAB,
      lazyLoadImage,
      isDynamicBadgeEnabledAbtest,
      guestAccessKey,
    } = this.props;
    const {
      miscInfo: { categoryId: categoryIdL3 },
      productInfo: {
        bundleProduct,
        generalProductId,
        name,
        long_product_title: longProductTitle,
        tcpStyleQty,
        tcpStyleType,
        primaryBrand,
        influencerTags,
        influencerPicks,
        TCPPrimaryCategory,
      },
      itemInfo: { itemId, quantity, availability, brand } = {},
      quantityPurchased,
      colorsMap,
      imagesByColor,
      recToken,
      fromFavorites,
      imageURL,
    } = item;
    const { extraConfig } = this.context;
    const { isDamImageV2Enabled, isDamImageV2EnabledPDP } = extraConfig || {};
    const itemNotAvailable = availability === AVAILABILITY.SOLDOUT;
    const prodNameAltImages = longProductTitle || name;
    const { selectedColorProductId, currentImageIndex, pdpUrl, hasMounted } = this.state;
    const suggestedItem = this.checkAndRenderSuggestedItem(item);
    const curentColorEntry = getMapSliceForColorProductId(colorsMap, selectedColorProductId);
    let imageUrls = getImagesToDisplay({
      imagesByColor,
      curentColorEntry,
      isAbTestActive: isOnModelAbTestPlp,
      isFavoriteView,
    });
    const isInWishList = checkInWishlistUtil(wishList, selectedColorProductId);
    imageUrls = getRearrangedImgUrls(imageUrls, curentColorEntry);
    const imageUrlsToShow = this.getImageCarouselOptions(imageUrls);
    const currentColorMiscInfo = this.getColorMiscInfo(curentColorEntry);
    const {
      badge1,
      keepAlive: keepAliveProduct,
      topRatedSLP,
      bestSellerSLP,
      mostFavoritedSLP,
      zoneOneBadges,
      zoneSixBadges,
    } = currentColorMiscInfo;
    const keepAlive = isKeepAliveEnabled && keepAliveProduct;
    const isFromPLPPage = isClient() && window?.location?.href?.includes(SLASH_C_ROUTE);
    const categoryIdToCheck = currentCategoryId || categoryIdL3 || categoryId;
    const topBadge = getTopBadge(isMatchingFamily, badge1);

    const {
      topRatedBadgeLabel = 'TOP RATED',
      bestSellerBadgeLabel = 'BEST SELLER',
      mostFavoritedBadgeLabel = 'MOST FAVORITED',
    } = this.productGridItemLabels || {};
    const isTopRatedSLP =
      !inGridPlpRecommendation && isTopRatedBadgeEnabledSLP && topRatedSLP && topRatedBadgeLabel;
    const isBestSellerSLP =
      !inGridPlpRecommendation &&
      isBestSellerBadgeEnabledSLP &&
      bestSellerSLP &&
      bestSellerBadgeLabel;
    const isMostFavoritedSLP =
      !inGridPlpRecommendation &&
      !isMostFavoritedBadgeEnabled &&
      mostFavoritedSLP &&
      mostFavoritedBadgeLabel;
    const influencerPickToDisplay =
      isSLP &&
      !inGridPlpRecommendation &&
      isInfluencerPicksEnabled &&
      influencerPicks &&
      influencerPicks[0];

    let isMountedTileRedesignAB = 'variationA';
    if (hasMounted && isTileRedesignAB === 'variationB') {
      isMountedTileRedesignAB = 'variationB';
    }
    if (hasMounted && !isTileRedesignAB) {
      isMountedTileRedesignAB = false;
    }

    let zoneOneBadgesArray = [];
    if (isTileRedesignAB && isSLP) {
      zoneOneBadgesArray = getZoneOneBadgesArray({
        zoneOneBadges,
        topRatedBadge: isTopRatedSLP,
        bestSellerBadge: isBestSellerSLP,
        mostFavoritedBadge: isMostFavoritedSLP,
        influencerPickToDisplay,
      });
    }

    const isShowBadges = currentImageIndex === 0;
    // NOTE: isClearance is a string 'Clearance', not a boolean we should clean this up globally in the abstractor
    const sqnNmb = sqnNmbr;
    const itemBrand = brand;
    const isProductBrandOfSameDomain = this.getIsProductBrandSameDomain();
    const googleAnalyticsData = this.updateGoogleAnalyticsData;
    const portalName = this.getRecIdentifier();
    let divProps;
    const isPdp = this.isPDP();
    const imageBorder = isNewPLPImageBorderEnabled ? 'image-tile-border' : '';
    if (widgetScrapeContentId) {
      divProps = {
        className: `item-container-inner ${isPdp}`,
        theme,
        id: widgetScrapeContentId,
        isHorizontalPLPCarouselEnabled,
      };
    } else {
      divProps = {
        className: `item-container-inner ${isPdp}`,
        theme,
        isHorizontalPLPCarouselEnabled,
      };
    }

    const SyteConfig = {
      image: `${getAssetHostURL()}/v1/ecom/assets/products/${getBrandName(
        primaryBrand,
        alternateBrand
      )}/${imageUrls?.[0]}`,
      sku: generalProductId,
      placement: 'PLP',
      clickAnalytics: trackAnalyticsClick,
    };
    const outOfStockCapsLabels = renderLabel(
      this.commmonBrowseLabels.lbl_common_outOfStockCaps,
      'lbl_common_outOfStockCaps'
    );
    return (
      <div
        className={`${className} horizontal-carousel-plp-product`}
        key={generalProductId}
        onMouseEnter={this.handleOpenAltImages}
        onMouseOut={this.handleCloseAltImages}
        onBlur={this.handleCloseAltImages}
        ref={forwardedRef}
      >
        {suggestedItem && suggestedItem.status && (
          <Recommendations
            {...suggestedItem.attributes}
            hasSuggestedProduct={suggestedItem.status}
            sequence="1"
          />
        )}
        <StyledItemContainerInner {...divProps}>
          {isSLP === true ? (
            <>
              {this.renderTopBadge({
                inGridPlpRecommendation,
                influencerPicks,
                isShowBadges,
                topBadge,
                isFavPage,
                isInfluencerPicksEnabled,
                isSLP,
                isMountedTileRedesignAB,
                zoneOneBadgesArray,
              })}
            </>
          ) : (
            <>
              {this.renderBadge({
                inGridPlpRecommendation,
                influencerPicks,
                isShowBadges,
                topBadge,
                isFavPage,
              })}
            </>
          )}
          {this.crossIcon()}
          {isSLP || isFavPage ? (
            <div className="relative">
              <StyledProductImageContainer
                theme={theme}
                isSuggestedItem={isSuggestedItem}
                pdpUrl={pdpUrl}
                loadedProductCount={loadedProductCount}
                viaModule={viaModule}
                dataSource={dataSource}
                imageUrls={imageUrlsToShow}
                fromFavorites={fromFavorites}
                imageURL={imageURL}
                productName={prodNameAltImages}
                onImageChange={this.handleImageChange}
                colorsMap={colorsMap}
                analyticsData={{
                  pId: generalProductId,
                  prank: sqnNmb,
                  requestId: unbxdId,
                }}
                keepAlive={keepAlive}
                isSoldOut={itemNotAvailable}
                soldOutLabel={outOfStockCapsLabels}
                itemBrand={itemBrand}
                isSearchPage={isSearchPage}
                page={page}
                isProductBrandOfSameDomain={isProductBrandOfSameDomain}
                isBundleProduct={bundleProduct}
                cookieToken={cookieToken}
                googleAnalyticsData={googleAnalyticsData}
                lowQualityEnabled={lowQualityEnabled}
                portalValue={portalValue && portalValue.length ? portalValue : portalName}
                dynamicBadgeOverlayQty={getDynamicBadgePackQty(
                  tcpStyleType,
                  tcpStyleQty,
                  isDynamicBadgeEnabledAbtest
                )}
                tcpStyleType={tcpStyleType}
                lazyLoad
                recToken={recToken}
                isSecureImageFlagEnabled={isSecureImageFlagEnabled}
                primaryBrand={primaryBrand || alternateBrand}
                alternateBrand={alternateBrand}
                isBopisFilterOn={isBopisFilterOn}
                categoryIdToCheck={categoryIdToCheck}
                setCurrentCategoryIdActn={setCurrentCategoryIdActn}
                isFromPLPPage={isFromPLPPage}
                isHorizontalPLPCarouselEnabled={isHorizontalPLPCarouselEnabled}
                className={`${isHorizontalPLPCarouselEnabled ? 'hr-plp' : ''} ${imageBorder} ${
                  isFavPage ? 'fav-redesign' : ''
                }`}
                isPLPImageHeightBasedOnAspectRatio={isPLPImageHeightBasedOnAspectRatio}
                inGridPlpRecommendation={inGridPlpRecommendation}
                renderTopRatedBadgeItem={this.renderTopRatedBadgeItem}
                renderBestSellerBadgeItem={this.renderBestSellerBadgeItem}
                renderMostFavoritedBadgeItem={this.renderMostFavoritedBadgeItem}
                topRatedSLP={topRatedSLP}
                bestSellerSLP={bestSellerSLP}
                mostFavoritedSLP={mostFavoritedSLP}
                isTopRatedBadgeEnabledSLP={isTopRatedBadgeEnabledSLP}
                isBestSellerBadgeEnabledSLP={isBestSellerBadgeEnabledSLP}
                isMostFavoritedBadgeEnabled={isMostFavoritedBadgeEnabled}
                preloadImage={preloadImage}
                trackClick={this.recommendationsTrackClickPDP}
                isHomePage={isHomePage}
                isDamImageV2Enabled={isDamImageV2Enabled}
                isDamImageV2EnabledPDP={isDamImageV2EnabledPDP}
                isInfluencerBadgeEnabled={isInfluencerBadgeEnabled}
                influencerTags={influencerTags}
                isSLP={isSLP}
                isFavoriteView={isFavoriteView}
                isMountedTileRedesignAB={isMountedTileRedesignAB}
                TCPPrimaryCategory={TCPPrimaryCategory}
                isFavPage={isFavPage}
              />
              {this.renderFavouriteIcon({
                bundleProduct,
                isFavoriteView,
                isInDefaultWishlist: isInWishList,
                itemNotAvailable,
                isSuggestedItem,
                isFavPage,
                fromBuyItAgain: false,
                isSLP: true,
                guestAccessKey,
              })}
            </div>
          ) : (
            <StyledProductImageContainer
              theme={theme}
              isSuggestedItem={isSuggestedItem}
              pdpUrl={pdpUrl}
              loadedProductCount={loadedProductCount}
              viaModule={viaModule}
              dataSource={dataSource}
              imageUrls={imageUrlsToShow}
              fromFavorites={fromFavorites}
              imageURL={imageURL}
              productName={prodNameAltImages}
              onImageChange={this.handleImageChange}
              colorsMap={colorsMap}
              analyticsData={{
                pId: generalProductId,
                prank: sqnNmb,
                requestId: unbxdId,
              }}
              keepAlive={keepAlive}
              isSoldOut={itemNotAvailable}
              soldOutLabel={outOfStockCapsLabels}
              itemBrand={itemBrand}
              isSearchPage={isSearchPage}
              page={page}
              isProductBrandOfSameDomain={isProductBrandOfSameDomain}
              isBundleProduct={bundleProduct}
              cookieToken={cookieToken}
              googleAnalyticsData={googleAnalyticsData}
              lowQualityEnabled={lowQualityEnabled}
              portalValue={portalValue && portalValue.length ? portalValue : portalName}
              dynamicBadgeOverlayQty={getDynamicBadgeQty(
                tcpStyleType,
                tcpStyleQty,
                isDynamicBadgeEnabledAbtest
              )}
              tcpStyleType={tcpStyleType}
              lazyLoad
              recToken={recToken}
              isSecureImageFlagEnabled={isSecureImageFlagEnabled}
              primaryBrand={primaryBrand || alternateBrand}
              alternateBrand={alternateBrand}
              isBopisFilterOn={isBopisFilterOn}
              categoryIdToCheck={categoryIdToCheck}
              setCurrentCategoryIdActn={setCurrentCategoryIdActn}
              isFromPLPPage={isFromPLPPage}
              isHorizontalPLPCarouselEnabled={isHorizontalPLPCarouselEnabled}
              className={`${isHorizontalPLPCarouselEnabled ? 'hr-plp' : ''} ${imageBorder}`}
              isPLPImageHeightBasedOnAspectRatio={isPLPImageHeightBasedOnAspectRatio}
              inGridPlpRecommendation={inGridPlpRecommendation}
              renderTopRatedBadgeItem={this.renderTopRatedBadgeItem}
              renderBestSellerBadgeItem={this.renderBestSellerBadgeItem}
              renderMostFavoritedBadgeItem={this.renderMostFavoritedBadgeItem}
              topRatedSLP={topRatedSLP}
              bestSellerSLP={bestSellerSLP}
              mostFavoritedSLP={mostFavoritedSLP}
              isTopRatedBadgeEnabledSLP={isTopRatedBadgeEnabledSLP}
              isBestSellerBadgeEnabledSLP={isBestSellerBadgeEnabledSLP}
              isMostFavoritedBadgeEnabled={isMostFavoritedBadgeEnabled}
              preloadImage={preloadImage}
              trackClick={this.recommendationsTrackClickPDP}
              isHomePage={isHomePage}
              isDamImageV2Enabled={isDamImageV2Enabled}
              isDamImageV2EnabledPDP={isDamImageV2EnabledPDP}
              isInfluencerBadgeEnabled={isInfluencerBadgeEnabled}
              influencerTags={influencerTags}
              isSLP={isSLP}
              isFavoriteView={isFavoriteView}
              lazyLoadImage={lazyLoadImage}
            />
          )}
          {this.renderDiscoveryButton(SyteConfig)}
          {!isFavPage &&
            isLoggedIn &&
            EditButton(
              {
                onQuickViewOpenClick,
                isFavoriteView,
                productGridItemLabels: this.productGridItemLabels,
                item,
                globalActions: this.globalActions,
              },
              selectedColorProductId,
              itemNotAvailable
            )}
          {isRecommendationProductInfoEnabled && this.getRenderProductInfo()}
          {this.renderCardTile(zoneSixBadges, isMountedTileRedesignAB, TCPPrimaryCategory)}
          {((isSLP === true && setPLPSLPAddToCartCTA === 'off') || !setPLPSLPAddToCartCTA) &&
          !isFavPage
            ? this.renderSubmitButton(keepAlive, itemNotAvailable, isHidePLPAddToBag)
            : null}
          {!inGridPlpRecommendation && isFavoriteView && !guestAccessKey
            ? this.renderFavoriteMovePurchaseSection(
                itemNotAvailable,
                quantity,
                quantityPurchased,
                itemId
              )
            : null}
          {this.dismissBtn()}
          {/* {error && <ErrorMessage error={error} />} */}
          {this.errorMsgDisplay()}
          {this.renderSuggestedError(
            hasSuggestedProduct,
            suggestedProductErrors,
            generalProductId,

            item,
            isFavoriteView
          )}
        </StyledItemContainerInner>
      </div>
    );
  }
}

const ProductsGridItemWithRef = forwardRef((props, ref) => {
  return <ProductsGridItem forwardedRef={ref} {...props} />;
});

export { ProductsGridItem as ProductsGridItemVanilla };

const ProductsGridItemStyled = withStyles(ProductsGridItemWithRef, styles);

// Display name is needed for hotfix mapping capability
ProductsGridItemStyled.displayName = 'ProductsGridItem';

export default ProductsGridItemStyled;
